import {filter} from './muteNodes';
export default function (callback) {
  let nodes;
  if (!arguments.length) { //모두 
    nodes = this.filterNodes().classed('mute', false).call(this.demute);
  } else {
    nodes = filter.call(this, callback);
    if (nodes.size() > 0) {
      nodes.classed('mute', false).call(this.demute);
    }
  }
  return this;
}


// WEBPACK FOOTER //
// ./layouts/default/demuteNodes.js